module.exports = __webpack_public_path__ + "static/media/1POLICY28.992401f1.jpg";